import React from 'react';
import './menuBar.css';

export default class MenuBar extends React.Component {

	render(){
		return(
			<div className="menu-bar">
				<a className="clickable btn-link" onClick={() => this.props.changeClasse('jogo')}>Jogos</a>
				<a className="clickable btn-link" onClick={() => this.props.changeClasse('util')}>Utilitários</a>
			</div>	
		);
	}
}


// WEBPACK FOOTER //
// ./src/menuBar.js